import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import { ArticleI18n, IArticleI18n } from './article-i18n';

export interface IArticle extends IEntity {
	readonly id: string;
	readonly localizations: ReadonlyArray<IArticleI18n>;
	readonly localization$: Observable<IArticleI18n>;
}

export class Article extends Entity implements IArticle {
	private _localizations: ArticleI18n[];
	private _localization$: Observable<ArticleI18n>;

	constructor(
		id: string,
		updateTimestamp: number,
		localizations: ArticleI18n[],
		localization$: Observable<ArticleI18n> = of(null)
	) {
		super(id, null, updateTimestamp);
		this._localizations = localizations;
		this._localization$ = localization$;
	}

	public get localizations(): ArticleI18n[] {
		return this._localizations;
	}

	public get localization$(): Observable<ArticleI18n> {
		return this._localization$;
	}
}
